import Image from './Image.component';

export default Image;